// @flow
import * as React from 'react'
import { ZentakeContext } from 'utils/ZentakeContext'

type Mode = 'office-use' | 'office' | string

export type SignatureAnswer = null | {|
  text: ?string,
  image: ?string,
  untrimmedImage?: ?string,
  id?: number,
|}

export type UseSignatureMemo = {
  memorizedSignature: SignatureAnswer,
  setMemorizedSignature: (signature: SignatureAnswer) => void,
  memorizedInitials: SignatureAnswer,
  setMemorizedInitials: (initials: SignatureAnswer) => void,
}

function isOfficeUse(mode?: Mode): boolean {
  return mode === 'office-use' || mode === 'office'
}

function useSignatureMemo(mode?: Mode): UseSignatureMemo {
  const { userDetails, teamConfig } = React.useContext(ZentakeContext)

  const shouldUseProfile =
    isOfficeUse(mode) && teamConfig?.enable_provider_signature

  const signatureAnswer =
    shouldUseProfile && userDetails?.provider_signature
      ? {
          text: null,
          image: userDetails.provider_signature,
        }
      : null

  const initialsAnswer =
    shouldUseProfile && userDetails?.provider_initials
      ? {
          text: null,
          image: userDetails.provider_initials,
        }
      : null

  const [memorizedSignature, setMemorizedSignature] =
    React.useState<SignatureAnswer>(signatureAnswer)

  const [memorizedInitials, setMemorizedInitials] =
    React.useState<SignatureAnswer>(initialsAnswer)

  return {
    memorizedSignature,
    setMemorizedSignature,
    memorizedInitials,
    setMemorizedInitials,
  }
}

export default useSignatureMemo
